import { Button } from '@malesia/react-components/dist/src/components/Button';
import { PageTitle } from '@malesia/react-components/dist/src/components/Page/Title';
import { SFC } from '@malesia/react-components/dist/src/types/react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { allAdminRoutePaths } from '../../../containers/Routes/allAdminRoutePaths';
import { flightListPermissions } from '../../../permissions/adminPages/flight/flightList';
import { useUserPermissions } from '../../../permissions/useUserPermissions';

export const FlightListHeaderWithStore: SFC = () => {
    const userPermissions = useUserPermissions();

    return (
        <PageTitle
            text={
                <FormattedMessage
                    id='front-app/FlightListPage:Title'
                    defaultMessage='Flights'
                />
            }
            rightSlot={
                <Link to={allAdminRoutePaths.flightNew}>
                    <Button
                        icon='plus'
                        text={
                            <FormattedMessage
                                id='front-app/Flight/List:AddFlight'
                                defaultMessage='New Flight'
                            />
                        }
                    />
                </Link>
            }
            rightSlotHidden={!userPermissions.has(flightListPermissions.newLink)}
        />
    );
};
